import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    id: "wrapper",
    class: _normalizeClass(["body-container", {'body-container-padding': _ctx.isCEF, 'body-container-launcher': _ctx.isLauncher}])
  }, [
    _createVNode(_component_RouterView, null, {
      default: _withCtx(({ Component, route }) => [
        (!route.path.startsWith('/workspace'))
          ? (_openBlock(), _createBlock(_Transition, {
              key: 0,
              name: route.meta.transition || 'fade',
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                Component
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: _ctx.getComponentKey(route)
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["name"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              Component
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: _ctx.getComponentKey(route)
                  }))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    })
  ], 2))
}